// Login.js - Şifremi unuttum linki eklenmiş versiyon

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import '../Auth.css';
import logo from '../../../assets/images/seedxpert-light.png';
import LanguageSwitcher from '../../../components/LanguageSwitcher/LanguageSwitcher';

const Login = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [emailNotVerified, setEmailNotVerified] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // Token varsa landing sayfasına yönlendir
  useEffect(() => {
    const token = localStorage.getItem('userToken');
    if (token) {
      navigate('/landing');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setEmailNotVerified(false);

    try {
      const res = await axios.post('/api/auth/login', { email, password });
      localStorage.setItem('userToken', res.data.token);
      setIsLoading(false);
      navigate('/landing');
    } catch (err) {
      setIsLoading(false);
      
      const errorData = err.response?.data;
      
      if (errorData?.emailNotVerified) {
        setEmailNotVerified(true);
        setUserEmail(errorData.email);
        setError(errorData.message);
      } else if (errorData?.accountNotActive) {
        setError(errorData.message);
      } else {
        setError(errorData?.message || t('auth.invalidCredentials'));
      }
    }
  };

  const handleResendVerification = async () => {
    try {
      await axios.post('/api/auth/resend-verification', { email: userEmail });
      setError(t('auth.verificationSent'));
      setEmailNotVerified(false);
    } catch (err) {
      setError(t('auth.verificationFailed'));
    }
  };

  return (
    <div className="auth-container">
      <div className="bg-animation">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="floating-shape shape-4"></div>
        <div className="floating-shape shape-5"></div>
        <div className="floating-shape shape-6"></div>
        <div className="floating-shape shape-7"></div>
      </div>

      <div className="auth-box">
        <div className="logo-section">
          <img
            src={logo}
            alt="SeedXpert Logo"
            className="auth-logo"
          />
        </div>
        <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
          <LanguageSwitcher />
        </div>
        <div className="auth-header">
          <h2>{t('auth.loginTitle')}</h2>
          <p className="auth-subtitle">{t('auth.loginSubtitle')}</p>
        </div>
        
        {error && (
          <div className={emailNotVerified ? "login-warning" : "error"}>
            {error}
            {emailNotVerified && (
              <p style={{ marginTop: '10px' }}>
                <span
                  className="resend-link"
                  onClick={handleResendVerification}
                >
                  {t('auth.resendVerification')}
                </span>
              </p>
            )}
          </div>
        )}
        
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>{t('common.email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('auth.emailPlaceholder')}
              required
            />
          </div>
          <div className="form-group">
            <label>{t('common.password')}</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t('auth.passwordPlaceholder')}
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
              >
                {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
              </button>
            </div>
          </div>

          {/* YENİ EKLEME - Şifremi unuttum linki */}
          <div className="forgot-password-section">
            <span
              className="forgot-password-link"
              onClick={() => navigate('/forgot-password')}
            >
              {t('auth.forgotPassword')}
            </span>
          </div>

          <button type="submit" className="auth-btn primary-btn" disabled={isLoading}>
            {isLoading ? (
              <>
                <span className="loading-spinner-login"></span>
                {t('common.loading')}
              </>
            ) : (
              t('common.login')
            )}
          </button>
        </form>
        <p className="switch-text register-text">
          {t('auth.noAccount')}{' '}
          <span className="switch-link" onClick={() => navigate('/register')}>
            {t('common.register')}
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login;